<script>
import Vue from 'vue';
import store from '../../store'
import {mapState, mapActions} from 'vuex';
import AdminList from '../AdminList/AdminList.vue';
import AdminEditModal from '../AdminEditModal/AdminEditModal.vue';
import AdminCreateModal from '../AdminCreateModal/AdminCreateModal.vue';
import InfoWidget from '../InfoWidget/InfoWidget.vue';
import Loading from '../Loading/Loading.vue';
import Alert from '../Alert/Alert.vue';

export default Vue.extend({
    components: {
        Alert,
        Loading,
        AdminList,
        InfoWidget,
        AdminEditModal,
        AdminCreateModal
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
            tips: state => state.admin.tips,
            editLoading: state => state.admin.editModal.form.loading,
            createLoading: state => state.admin.createModal.form.loading,
            supplier: state => state.auth.supplier
        })
    },
    watch: {
        supplier: (supplier) =>  {
            store.dispatch('admin/getUsers', supplier.id);
            store.dispatch('admin/getRoles', supplier.id);
            store.dispatch('nav/toggleNavMenu', false);
        }
    },
    created () {
        const supplierId = this.supplier.id;
        this.getUsers(supplierId);
        this.getRoles(supplierId);
        this.getLanguages();
        this.toggleNavMenu(false);
    },
    methods: {
        ...mapActions({
            getUsers: 'admin/getUsers',
            getRoles: 'admin/getRoles',
            getLanguages: 'admin/getLanguages',
            toggleNavMenu: 'nav/toggleNavMenu',
        })
    }
});
</script>

<template>
    <div class="admin-page">
        <div class="admin-page__header">
            <div class="admin-page__heading">
                {{ $t('admin.heading.header') }}
            </div>
        </div>
        <div class="admin-page__list">
            <admin-list/>
        </div>
        <div class="admin-page__edit-modal">
            <admin-edit-modal/>
        </div>
        <div class="admin-page__edit-modal">
            <admin-create-modal/>
        </div>
        <info-widget ref="infoWidget" :tips="tips"/>
        <loading v-if="editLoading || createLoading"/>
        <alert :translation-prefix="'admin.alert'"/>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AdminPage/AdminPage.vue